import { render, staticRenderFns } from "./AgreementPopup.vue?vue&type=template&id=371a9756&scoped=true&"
import script from "./AgreementPopup.vue?vue&type=script&lang=js&"
export * from "./AgreementPopup.vue?vue&type=script&lang=js&"
import style0 from "./AgreementPopup.vue?vue&type=style&index=0&id=371a9756&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371a9756",
  null
  
)

export default component.exports